function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#b58e3b"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M60 49.114a5 5 0 01-2.5 4.329l-25 14.444a5 5 0 01-5 0l-25-14.444A5 5 0 010 49.114v-28.9a5 5 0 012.5-4.329l25-14.44a5 5 0 015 0l25 14.445a5 5 0 012.5 4.329z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M55 20.219L30 5.775 5 20.219v28.895L30 63.56l25-14.445V20.22m5 0v28.895a5 5 0 01-2.499 4.33l-25 14.444a5 5 0 01-5.002 0l-25-14.444A5 5 0 010 49.114V20.22a5 5 0 012.499-4.33l25-14.444a5 5 0 015.002 0l25 14.445A5 5 0 0160 20.219z",
  fill: "rgba(255,255,255,.21)"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.179 47.741l-10.9-11.83a7.872 7.872 0 0111.128-11.137L30 26.184l1.587-1.4a7.871 7.871 0 0111.134 11.125l-10.9 11.836a2.419 2.419 0 01-3.637-.006zm1.091-.994a.945.945 0 001.455.005l10.91-11.842.039-.039a6.4 6.4 0 00-9.04-9.049.746.746 0 01-.055.053l-2.09 1.847a.747.747 0 01-.087.066l-.011.007h-.014l-.011.006a.733.733 0 01-.184.073h-.265a.733.733 0 01-.289-.1H29.615a.761.761 0 01-.087-.065l-2.104-1.834a.749.749 0 01-.055-.053 6.4 6.4 0 00-9.024 9.067l.005.006.021.022z",
  fill: "#fff"
});

var SvgAchievementRelationship = function SvgAchievementRelationship(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      viewBox: "0 0 60 70",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgAchievementRelationship, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/AchievementRelationship.0cca8a8b.svg";
export { ForwardRef as ReactComponent };